/* Product-only rollout: one form handler and the existing Rebuy cart.
   Shopify's native product form remains the no-JavaScript fallback. */
(function () {
  'use strict';
  var CU = window.CU;
  if (!CU || !CU.liveCart) return;
  var adding = false;
  var usedRebuy = false;
  function rebuyCart() {
    return window.Rebuy && Rebuy.Cart && Rebuy.SmartCart && Rebuy.Cart.addItem ? Rebuy : null;
  }
  function readyCart() {
    return new Promise(function (resolve) {
      var started = Date.now();
      function check() {
        var cart = rebuyCart();
        if (cart || Date.now() - started > 3000) { resolve(cart); return; }
        setTimeout(check, 100);
      }
      check();
    });
  }
  CU.beginCartAdd = function () {
    if (adding) return false;
    adding = true;
    return true;
  };
  CU.prepareCartAdd = function (items) { return Promise.resolve(items); };
  CU.submitCartItems = function (items) {
    return readyCart().then(function (rebuy) {
      usedRebuy = !!rebuy;
      if (rebuy) {
        return new Promise(function (resolve, reject) {
          rebuy.Cart.addItem({ items: items }, {
            success: function (data) { resolve(data || {}); },
            error: function (error) { reject(new Error(error && error.description || 'This item could not be added to your bag.')); }
          });
        });
      }
      return fetch(CU.routes.cartAdd, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'This item could not be added to your bag.');
          return data;
        });
      });
    });
  };
  CU.showAddedCart = function () {
    if (usedRebuy && rebuyCart()) Rebuy.SmartCart.show();
    else window.location.assign(CU.routes.cart);
    return Promise.resolve();
  };
  CU.finishCartAdd = function () { adding = false; };
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cu-cart-toggle]');
    if (!button) return;
    event.preventDefault();
    if (rebuyCart()) Rebuy.SmartCart.show();
    else window.location.assign(CU.routes.cart);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cu-buybox] form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var data = new FormData(form);
    CU.addItems(form, [{ id: data.get('id'), quantity: parseInt(data.get('quantity'), 10) || 1 }], document.querySelector('[data-cu-buybar-add]'));
  }, true);
})();
